<template>
  <Question
    :next-button-theme="nextButtonTheme"
    :subtitle="$t('kyc.titles.identity')"
    :title="$t('kyc.questions.childrenDetails')"
    :progress-ratio="6/8/4"
    back-route="/kyc/children"
    @next="next"
  >
    <BaseSection>
      <BaseInputGroup
        v-for="(age, index) in childrenAges"
        v-model="age.value"
        :key="childrenAges.indexOf(age)"
        :label="$t('kyc.labels.childrenDetails', { index: (index + 1) })"
        :class="{'mb-4': (index < childrenAges.length - 1) }"
        :placeholder="$t('Years')"
        type="number"
      />
      <BaseAddLine
        class="text-xl mb-4"
        theme="orange"
        @click.native="addChild"
      >
        Ajouter une personne
      </BaseAddLine>
    </BaseSection>
  </Question>
</template>

<script>
import { mapMultiRowFields } from 'vuex-map-fields';
import Question from './Question.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseTitleGroup from '../../components/BaseTitleGroup.vue';
import BaseInputGroup from '../../components/BaseInputGroup.vue';
import BaseAddLine from '../../components/BaseAddLine.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'ChildrenDetails',
  components: {
    Question,
    BaseInputGroup,
    BaseTitleGroup,
    BaseSection,
    BaseAddLine,
  },
  mixins: [kyc],
  computed: {
    ...mapMultiRowFields('kyc', ['form.attributes.childrenAges']),
    nextButtonTheme() {
      if (this.childrenAges.length && this.childrenAges[0].value) {
        return 'primary';
      }
      return 'disabled';
    },
  },
  methods: {
    addChild() {
      this.form.attributes.childrenAges.push({ value: null });
    },
    next() {
      this.update();
      this.$router.push('/kyc/ppe');
    },
  },
};
</script>
